<template>
  <div
    id="app"
    v-docked-class
    class="wrapper"
    :class="backgroundClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  computed: {
    backgroundClass() {
      return this.$route.meta.backgroundColor !== undefined ? `wrapper--${this.$route.meta.backgroundColor}` : undefined
    }
  }
}
</script>
